// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"057d3ebe","254":"a14f9148"}[chunkId] + ".chunk.js";
};